import { Badge } from "@/components/ui/badge";
import { cn } from "@/lib/utils";
import type { AcademyArticle } from "@/lib/academy/articles";

/** Stufen-Badge (2026-08-19-Großausbau, backlog.md -> [Punkt 34], "Inhalte gestaffelt
 * nach Anfänger/Fortgeschritten/Experte") - dieselbe Drei-Ton-Logik wie an anderen
 * Hervorhebungs-Stellen im Projekt (grün für "einfach/einladend", Gold als bestehender
 * Akzent, Navy für "fortgeschritten/ernst"), keine neuen Farben außerhalb der
 * etablierten Palette. Eigene kleine, gemeinsam genutzte Komponente statt die
 * Farblogik in academy-search.tsx UND der Artikelseite separat zu pflegen. */
const LEVEL_STYLES: Record<NonNullable<AcademyArticle["level"]>, string> = {
  Einsteiger: "border-transparent bg-positive/10 text-positive",
  Fortgeschritten: "border-transparent bg-gold/15 text-gold-text",
  Experte: "border-transparent bg-primary/10 text-primary",
};

export function LevelBadge({ level, className }: { level?: AcademyArticle["level"]; className?: string }) {
  if (!level) return null;
  return <Badge className={cn(LEVEL_STYLES[level], className)}>{level}</Badge>;
}
